<!-- Translated: skip -->
<template>

  <div>

    <h2 class="ingress">BOKA VÅRA FÖRMÅNLIGA PERIODLIFTKORT</h2>
    <p><strong>Köper du våra periodkort får du alltid förmånliga priser.<br />
    </strong>
    </p>
    <h3>HELGKORT</h3>
    <p><em>(Gäller tor-sön)<br />
    </em>Vuxen: 1240:-<span style="color: #ff0000;"><br />
    </span>Ungdom: 960:-</p>
    <h3>KORTVECKA</h3>
    <p><em>(Gäller sön-tor)<br />
    </em>Vuxen: 1520:-<span style="color: #ff0000;"><br />
    </span>Ungdom: 1225:-</p>
    <h3>VECKA</h3>
    <p><em>(Gäller sön-sön eller tor-tor)<br />
    </em>Vuxen: 1830:-<span style="color: #ff0000;"><br />
    </span>Ungdom: 1420:-</p>
    <p>Under jul och nyår ger vi helg- och kortveckopriser på våra 4- och 5-dagarskort (när kortet följer boendeperioden), priset är justerat i onlinebokningen.</p>

    <Collapsable title="Så fungerar det med liftkort" content="
      <p>I Branäs använder vi ett så kallat keycard på vilket du kan ladda ditt liftkort. Du använder sedan detta kort för att komma in till liftarna. Du laddar kortet med den tid du vill åka skidor, från tre timmar och uppåt.</p>
      <p>Alla barn under åtta år åker gratis. De behöver dock ett keycard för att kunna åka och det kostar 55kr. När du har köpt ett keycard så kan du spara det till nästa säsong och det fungerar dessutom i våra övriga anläggningar som exempelvis Kungsberget och Vallåsen.</p>
      <div class='clickable button-box'>
          <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>
      </div>
      <p>
      </p>
      "
      />

    <Collapsable title="Här köper du liftkort" content="
      <p>Du kan köpa ditt liftkort redan nu på webben. Då kan du köpa ett helt nytt liftkort eller ladda på ett befintligt keycard, se ”Så fungerar det med liftkort” här ovanför, för att läsa mer om liftkort och keycard.</p>
      <div class='clickable button-box'>
          <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>
      </div>
      <p> </p>
      <p>Du kan också köpa liftkortet på plats i Branäs, i våra infocenter, skidhyrorna, sportshopen och i våra närlivsbutiker. På pistkartan hittar du inköpsställen för våra liftkort.</p>
      <div class='clickable button-box small-button'>
          <a href='/skidakning/backar-och-liftar/#pistkartor'>Till våra pistkartor   </a><i class='fa fa-arrow-right'></i>
      </div>
      <p>
      </p>
      "
      />

    <Collapsable title="Tips - Undvik köer, köp dina liftkort på webben!" content="
      <p>Om du köper dina liftkort redan nu på webben så levereras de direkt i ert incheckningskuvert när ni kommer fram. På så sätt slipper ni börja semestern med att köa och kan snabbt ge er ut i backarna.</p>
      <div class='clickable button-box'>
          <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>
      </div>
      <p>
      </p>
      "
      />

    <div class="following-info">
        <h2 id="ladda-liftkort">Ladda liftkort</h2>

        <p>Har ni redan befintliga keycard hemma? Ladda korten enkelt via ”Ladda liftkort” nedan. Liftkortet kan användas när som helst under säsongen och aktiveras när du använder det första gången.</p>
        <p>”Ladda liftkort” öppnar under hösten 2017, önskar ni ladda era keycard redan nu ring oss på 054-13 26 00 eller klicka er in på vår <a href="/boka/boka-online/#search/1001">onlinebokning</a>.</p>
        <p> </p>
        <p>1. <strong>Ladda</strong> ditt keycard med önskat antal åkdagar.</p>
        <p>2. <strong>Betala</strong> med kort eller via Swish.</p>
        <p>3. Nu är det bara att åka!</p>
        <div class="clickable button-box center">
            <a href="https://hyra.branas.se/liftkort" target="_blank">Ladda liftkort   </a><i class="fa fa-arrow-right"></i>
        </div>
        <h2 id="gratis-for-barn">Gratis för barn</h2>

        <p>I Branäs är alla aktiviteter gratis för barn med liftkort. Är barnen under åtta år bjuder vi dessutom på liftkortet. Men glöm inte att barnen behöver ett eget keycard som kostar 55kr, läs mer om liftkort och keycard under boxen ”<span style="font-weight: 400;">Så fungerar det med liftkort”</span><span style="font-weight: 400;"> här ovanför.</span>
            <br><strong><span style="font-weight: 400;">För lite extra energipåfyllning ute i backen bjuder vi alla barn på varm ekologisk saft.</span></strong>
        </p>
        <p>Se mer om alla <a title="För barn" href="/barn-bjornbusen-branas/">roliga aktiviteter som är gratis för barn</a>.</p>
        <h2 id="dela-liftkort">Dela liftkort med föräldrakortet</h2>

        <p>Föräldrakortet är perfekt för föräldrar som reser till Branäs med små barn. Köp ett kort gemensamt och dela med din partner, en av er kan vara med barnen och en kan åka skidor.</p>
        <div class="clickable button-box center">
            <a href="/boka/boka-online/#search/1001">Köp liftkort online   </a><i class="fa fa-arrow-right"></i>
        </div>
        <h2 id="priser-for-liftkort">Priser och varianter</h2>

        <p> </p>
        <p> </p>
        <p class="has-image"><img class="alignnone size-medium wp-image-6860" src="https://www.branas.se/wp-content/uploads/2016/12/skidskola-470x385.jpg" alt="skidskola" width="470" height="385">
        </p>
        <h3>liftkort 2017-18</h3>
        <table class="responsive price-table">
            <thead>
                <tr>
                    <th></th>
                    <th class="number">Vuxen</th>
                    <th class="number">Ungdom</th>
                    <th class="number">Föräldrakort</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>3 timmar</td>
                    <td class="number"> 360</td>
                    <td class="number"> 285</td>
                    <td class="number"></td>
                </tr>
                <tr>
                    <td>1 dag</td>
                    <td class="number"> 405</td>
                    <td class="number"> 315</td>
                    <td class="number"> 570</td>
                </tr>
                <tr>
                    <td>2 dagar</td>
                    <td class="number"> 795</td>
                    <td class="number"> 625</td>
                    <td class="number"> 1110</td>
                </tr>
                <tr>
                    <td>3 dagar</td>
                    <td class="number"> 1140</td>
                    <td class="number"> 905</td>
                    <td class="number"> 1600</td>
                </tr>
                <tr>
                    <td>Långhelg (to–sö)</td>
                    <td class="number">1240</td>
                    <td class="number"> 960</td>
                    <td class="number"> 1740</td>
                </tr>
                <tr>
                    <td>4 dagar</td>
                    <td class="number"> 1455</td>
                    <td class="number"> 1140</td>
                    <td class="number"> 2040</td>
                </tr>
                <tr>
                    <td>Kortvecka (sö–to)</td>
                    <td class="number"> 1520</td>
                    <td class="number"> 1225</td>
                    <td class="number"> 2130</td>
                </tr>
                <tr>
                    <td>5 dagar</td>
                    <td class="number"> 1725</td>
                    <td class="number"> 1375</td>
                    <td class="number"> 2420</td>
                </tr>
                <tr>
                    <td>Vecka (6–8 dagar)</td>
                    <td class="number"> 1830</td>
                    <td class="number"> 1420</td>
                    <td class="number"> 2560</td>
                </tr>
                <tr>
                    <td>9 dagar</td>
                    <td class="number"> 1950</td>
                    <td class="number"> 1525</td>
                    <td class="number"> 2730</td>
                </tr>
                <tr>
                    <td>10 dagar</td>
                    <td class="number"> 2120</td>
                    <td class="number"> 1610</td>
                    <td class="number"> 2970</td>
                </tr>
                <tr>
                    <td>11 dagar</td>
                    <td class="number"> 2340</td>
                    <td class="number"> 1690</td>
                    <td class="number"> 2970</td>
                </tr>
                <tr>
                    <td>12 dagar</td>
                    <td class="number"> 2470</td>
                    <td class="number"> 1770</td>
                    <td class="number"> 3460</td>
                </tr>
                <tr>
                    <td>13 dagar</td>
                    <td class="number"> 2640</td>
                    <td class="number"> 1860</td>
                    <td class="number"> 3700</td>
                </tr>
                <tr>
                    <td>14 dagar</td>
                    <td class="number"> 2760</td>
                    <td class="number"> 1950</td>
                    <td class="number"> 3860</td>
                </tr>
                <tr>
                    <td>Säsongskort</td>
                    <td class="number"> 4595</td>
                    <td class="number"> 3495</td>
                    <td class="number"></td>
                </tr>
            </tbody>
        </table>
        <p> </p>
        <h3>Priskategorier</h3>
        <p>Vuxen: 18 år-
            <br> Ungdom: 7-17 år
            <br> Barn: 0-6 år</p>
        <p>Keycard krävs för att kunna ladda på ett liftkort, det kostar 55 kr. Spara ditt Keycard till nästa säsong och ladda det på nytt.</p>
        <p> </p>
        <div class="clickable button-box center">
            <a href="/boka/boka-online/#search/1001">Köp liftkort online   </a><i class="fa fa-arrow-right"></i>
        </div>
      </div>

  </div>

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Collapsable from '@/components/components/Collapsable';

import Page from '@/components/parts/Skipass/Page';

export default {
  components: {
    Collapsable,
    Page,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'guidedPasses',
    ]),
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    open() {
      this.openModal(['SkiPassPickDate']);
    },
  },
};
</script>

<style scoped lang="styl">
</style>



// WEBPACK FOOTER //
// Page.vue?3d3fc586